import toast from "react-hot-toast";
import { SnackbarError } from "./base/SnackbarAlert/SnackbarError";
import { SnackbarSuccess } from "./base/SnackbarAlert/SnackbarSuccess";

export const successToast = (message) => {
    toast.custom(() => <SnackbarSuccess message={message} />, {
        position: "bottom-right",
    });
};
export const errorToast = (message) => {
    toast.custom(() => <SnackbarError message={message} />, {
        position: "bottom-right",
    });
};
